import type { HomePage, UmbracoContentList } from "../models"
import { DeciderPWAHttpService } from "./utils"

export class ContentService extends DeciderPWAHttpService {
	constructor() {
		// super("https://localhost:44307/umbraco/delivery/api/v2/content")
		super("https://pwa-admin.thedecider.org.uk/umbraco/delivery/api/v2/content")
	}

	async getContent() {
		return await this.returningJson<UmbracoContentList<HomePage>>().get(`?filter=contentType:home&expand=properties[skillSets[properties[lessons]],lessons]`)
	}
}
